/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureProduct.tsx
 *
 * Project Title :  Checkout
 *
 * Description	:
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja.P(H27743)
 *
 * @Date			    : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 *  By            : Sivateja (H267743)
 * On            : Aug 08, 2019
 * Description   : implemented the tick icons for configure product (ASDS-906)
 *
 *By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : added fields that are needed for save cart service integration(ASDS-909)
 *
 * By            : H352615
 * On            : Aug 26, 2019
 * Description   : Updated code as ASDS-1084.
 *
 * By            : h267743
 * On            : Oct 14, 2019.
 * Description   : ASDS-1477 - fixed inline loader
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 *
 * By            : H175591
 * On            : 01 Nov 2019
 * Description   : ASDS-588
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Dec 12, 2019
 * Description   : ASDS-2083 - Updated scuf libraries to latest version. Icons updated.
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3823 - Aspire UI enhancements of Phase-2
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3572,ASDS-3573 Enhancements of phase-2 - Edit Aspire product changes
 *
 * By            : H422337
 * On            : Nov 18, 2020
 * Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2
 *
 ******************************************************************************/
import * as React from "react";
import { Select, Grid, Card, Icon, Notification} from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import '@scuf/datatable/honeywell/theme.css';
import "./configureFeatures.css";
import { connect } from "react-redux";
import { InLineLoader } from "../Loader/Loader";
import ConfigureProductActions from '../redux/actions/configure-product-actions';

import { ICellData } from "@scuf/datatable/dist/components/DataTable/IDataTableInterfaces";
import { ApuErrorLabels } from "../constants/checkout-constants";

interface IConfigureFeatureProps {
  deleteFeature: Function;
  addNewFeature: Function;
   updateFeature: Function;
   productFeatureMasterData: any;
   productFeatures: any;
   productSerialNumbers: any;
   isFeatureMasterDataFetching: boolean;
   hideAspireValidationErrorMsg: Function;
   showAspireValidationErrorMsg: boolean;
}

class ConfigureFeature extends React.Component<
  IConfigureFeatureProps,
  any
  > {
  constructor(props: IConfigureFeatureProps) {
    super(props);

    this.state = {
        selectedRowData : [] as any,

      showFeatureNotification: true
      // validityOptions: props.validityOptions,
    };
  }

  //getSelectedValue(value: string) {
    //this.handlePartNumberChanged(value);
    // const notificationErrorFeature = {
    //   subProductId: "",
    //   subProductName: "",
    //   subProductDesc: "",
    //   partNumber: "",
    //   validity: "",
    //   unitPrice: "0.00",
    //   extendedPrice: "0.00",
    //   partNumberError: "",
    //   validityError: "",
    //   discountedPrice: "",
    //   discountPercentage: "",
    // };
  //}

  //handlePartNumberChanged(selectedPartNumber: string) {
    // filter the master data with given partnumber and get all the price for the validatity options.
  //   const filteredproductFeatureMasterData = this.props.productFeatureMasterData.filter(
  //     featuremst => {
  //       return (
  //         selectedPartNumber.toLowerCase() ===
  //         featuremst.partNumber.toLowerCase()
  //       );
  //     }
  //   );
  //   // let validtyOptions= [];
  //   if (filteredproductFeatureMasterData.length > 0) {
  //     const feature = {
  //       ...this.props.feature,
  //       partNumber: selectedPartNumber,
  //       subProductName: filteredproductFeatureMasterData[0].subProductName,
  //       subProductDesc: filteredproductFeatureMasterData[0].subProductDesc,
  //       subProductId: filteredproductFeatureMasterData[0].subProductId,
  //       validity: filteredproductFeatureMasterData[0].term,
  //       unitPrice: filteredproductFeatureMasterData[0].price,
  //       notes: filteredproductFeatureMasterData[0].notes
  //     };
  //     this.setState({
  //       feature
  //     });
  //     this.props.updateFeature(feature, this.props.index);
  //     // if (filteredproductFeatureMasterData[0].notes) {
  //     //   this.props.showFeatureNotificationFunction(this.props.index, true);
  //     // } else {
  //     //   this.props.showFeatureNotificationFunction(this.props.index, false);
  //     // }
  //   }

  // }

  // onNotificationClose() {
  //   this.setState({
  //     showFeatureNotification: false
  //   });
  //   // const feature = {
    //   ...this.props.feature,
    //   showFeatureNotification: false
    // };
    // this.setState({
    //   feature,
    //   showFeatureNotification: false
    // });
    //this.props.showFeatureNotificationFunction(this.props.index, false);
  //}

  // handleValidityChanged(selectedValidity: string) {
  //     const filteredproductFeatureMasterData = this.props.productFeatureMasterData.filter((featuremst) => {
  //         return this.props.feature.partNumber.toLowerCase() === featuremst.partNumber.toLowerCase();
  //     });
  //     let unitPrice = '0.0';
  //     let discountPercentage = '0';
  //     let discountedPrice = '0';
  //     const filteredPriceArray = filteredproductFeatureMasterData[0].price.filter(row => {
  //         return row.term === selectedValidity;
  //     });
  //     if (filteredPriceArray.length > 0) {
  //         unitPrice = filteredPriceArray[0].price;
  //         discountedPrice = filteredPriceArray[0].discountedPrice;
  //         discountPercentage = filteredPriceArray[0].discountPercentage;
  //     }
  //     const feature = { ...this.props.feature, validity: selectedValidity, unitPrice: unitPrice, extendedPrice: unitPrice, discountedPrice, discountPercentage };
  //     this.setState({
  //         feature: feature
  //     });
  //     this.props.updateFeature(feature, this.props.index);
  // }
  partNumberRenderer(cellData: ICellData) {
    const partNumberOptions = this.props.productFeatureMasterData.map((feature) => {
      return { value: feature.partNumber, text: feature.partNumber + ' (' + feature.subProductName + ')' };
    });

    return (
      <React.Fragment>
      <Select
        key={cellData.rowIndex}
        placeholder="Enter or Select "
        value={cellData.rowData.partNumber}
        search={true}
        onChange={(value: any) => { this.updatePartNumber(value, cellData); }}
        options={partNumberOptions}
      />
      </React.Fragment>
    );
  }
  updatePartNumber(value, index) {
    this.updateSelectedRowData(index)
    const filteredproductFeatureMasterData = this.props.productFeatureMasterData.filter(
          featuremst => {
            return (
              value.toLowerCase() ===
              featuremst.partNumber .toLowerCase()
            );
          }
        );
    this.props.hideAspireValidationErrorMsg(true);
    this.props.updateFeature(filteredproductFeatureMasterData[0], index.rowIndex);

  }


unitPriceDisplay( cellData: ICellData) {
  return <span>${parseFloat(cellData.value).toFixed(2)}</span>;
}

extendedPriceDisplay( cellData: ICellData) {
  let extendedPrice = this.props.productSerialNumbers.length * parseFloat(cellData.rowData.unitPrice);
  return <span>${extendedPrice.toFixed(2) }</span>;
}
deleteFeature(){
  this.props.deleteFeature(this.state.selectedRowData);
  this.setState({ selectedRowData: [] });

}

updateSelectedRowData(cellData: ICellData) {
  if (this.state.selectedRowData.length !== 0) {
      const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => x.partNumber === cellData.rowData.partNumber);
      if (indexFromSelectedRowData !== -1) {
              let  selecedData = [...this.state.selectedRowData];
              selecedData.splice(indexFromSelectedRowData, 1);
              this.setState({selectedRowData: selecedData});
      }
  }
}

  render() {
    const Item = DataTable.ActionBar.Item;

    let ErrorRowData = this.props.productFeatures.filter((product: any) => {
      if (typeof product.partNumberError !== 'undefined' && product.partNumberError !== ''  || typeof product.notes !== 'undefined' ){
          return product;
      }
});
    if (this.props.isFeatureMasterDataFetching) {
      return (
        <InLineLoader text="Loading Features" loading={true} overlayColor="transparent" inlineclassname="configureFeaturesLoader"> </InLineLoader>

      );
    } else {
      return (
        <React.Fragment>
        <Card className="fullwidthCard">
            <Card.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12} className="fullwidthRow msa-flow-panel">
                          <DataTable
                            data={this.props.productFeatures}
                            selectionMode="single"
                            selection={this.state.selectedRowData}
                            onSelectionChange={(e) => {
                              console.log(e);
                              this.setState({ selectedRowData: e });
                            }}
                            expandedRows={ ErrorRowData }
                            rowExpansionTemplate={(data) => this.rowExpansionTemplate(data)}
                          >
                            <DataTable.HeaderBar>
                                    <DataTable.HeaderBar.Item
                                        content="Add"
                                        iconSize="small"
                                        icon="slidercontrols-plus"
                                        onClick={() => this.props.addNewFeature()}
                                    />
                            </DataTable.HeaderBar>
                            <DataTable.ActionBar>
                                <Item
                                    icon={<Icon name="delete" root="common" size="small" />}
                                    content="Delete"
                                    onClick={() => this.deleteFeature()}
                                />
                            </DataTable.ActionBar>
                            <DataTable.Column field="partNumber" header="Part Number- Feature Name"  align="left"  renderer={(cellData) => this.partNumberRenderer(cellData) }/>
                            <DataTable.Column field="validity" header="Validity" align="left" />
                            <DataTable.Column field="unitPrice" header="Unit Price"  renderer={this.unitPriceDisplay}  align="left"/>
                            <DataTable.Column field="extendedPrice" header="Extended Price & Details" renderer={(cellData) => this.extendedPriceDisplay(cellData)} align="left"/>
                          </DataTable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
        </React.Fragment>
      );

    }
  }
  rowExpansionTemplate(data){
         let errorMsg: string = '';
         let errorTitle: string = '';


         if (data.partNumberError !== '') {
     errorMsg = data.partNumberError;
    if (errorMsg === 'Please Select part number'){
    errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
        }
    else {
       errorTitle = 'This Part Number mentioned above already exist!';
    }
     }
         if (this.props.showAspireValidationErrorMsg) {
             if (errorTitle === ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR ){
                return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAspireValidationErrorMsg(false); }} >{errorMsg}</Notification>;
            }
        else if(errorTitle === 'This Part Number mentioned above already exist!' ) {
           return  <Notification hasIcon={true} severity="critical"   title={errorTitle} style={{margin: 0}} onCloseClick={() => this.props.hideAspireValidationErrorMsg(false)} >{errorMsg}</Notification>;
       }
       else {
         return <Notification hasIcon={true} severity="information"   title="This feature will not work" style={{margin: 0}} onCloseClick={() => this.props.hideAspireValidationErrorMsg(false)} >{data.notes}</Notification>;
       }
      }
       else{
          return <span></span> ;
       }
    }
}

const mapDispatchToProps = {
  getProductFeaturesMasterData: ConfigureProductActions.getFeaturesMasterData,
    deleteFeature: ConfigureProductActions.deleteFeature,
    addNewFeature: ConfigureProductActions.addNewFeature,
    updateFeature: ConfigureProductActions.updateFeature,
    hideAspireValidationErrorMsg: ConfigureProductActions.hideAspireValidationErrorMsg
};

function mapStateToProps(state) {
  return {
    productFeatureMasterData:
      state.configProductData.payload.featuresMasterData,
    productFeatures: state.configProductData.payload.productFeatures,
    productSerialNumbers: state.configProductData.payload.serialNumbers,
    isFetching: state.configProductData.payload.isFetching,
    isFeatureMasterDataFetching:
      state.configProductData.payload.isFeatureMasterDataFetching,
      showAspireValidationErrorMsg: state.configProductData.payload.showAspireErrorValidationMsg

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureFeature);
